import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Simulation } from 'src/app/models';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() simulation!: Simulation;
  @Input() title: string = '';
  @Input() info: string = '';

  private history: string[] = [];

  constructor(
    private router: Router,
    private location: Location
  ) {}

  ngOnInit() {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.history.push(event.urlAfterRedirects);
    });
  }

  back() {
    this.location.back();
  }

  volverInicio(): void {
    this.router.navigate(['/home']);
  }
}
